import { render, staticRenderFns } from "./PaymentStepTitle.vue?vue&type=template&id=9b32e4b0&scoped=true&"
import script from "./PaymentStepTitle.vue?vue&type=script&lang=js&"
export * from "./PaymentStepTitle.vue?vue&type=script&lang=js&"
import style0 from "./PaymentStepTitle.vue?vue&type=style&index=0&id=9b32e4b0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b32e4b0",
  null
  
)

export default component.exports